<ng-container *ngIf="!editable">
  <i *ngFor="let item of stars; let i = index" [ngClass]="getStarClass | call: item"></i>
</ng-container>

<ng-container *ngIf="editable">
  <i
    *ngFor="let item of [1, 2, 3, 4, 5]; let i = index"
    (click)="onVote(item)"
    (mouseenter)="onHover(item)"
    [ngClass]="{ fas: hoverIndex > i, far: hoverIndex <= i }"
    class="rating-star fa-star"
  ></i>
</ng-container>
